import { render, staticRenderFns } from "./HeadlineTextBlock.vue?vue&type=template&id=08a28908&scoped=true"
import script from "./HeadlineTextBlock.vue?vue&type=script&lang=ts"
export * from "./HeadlineTextBlock.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineTextBlock.vue?vue&type=style&index=0&id=08a28908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a28908",
  null
  
)

export default component.exports